import { getAmplitudeInstance } from '../amplitudeHelpers';

type logHeatmapFilterTappedParams = {
  activity_tapped?: string;
  time_range_tapped?: string;
};

/**
 * The user taps one of the filter options in the heatmap filter menu.
 * @param params - Attributes to log with the amplitude event
 * @param params.activity_tapped - The activity the user chose to filter the heatmaps by. NULL if the user interacted with time range.
 * @param params.time_range_tapped - The time range the user choce to filter the heatmaps by. NULL if the user interacted with activity tapped.
 */
const logHeatmapFilterTapped = ({ activity_tapped, time_range_tapped }: logHeatmapFilterTappedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('heatmap filter tapped', { 'activity tapped': activity_tapped, 'time range tapped': time_range_tapped }, callback);
};

export default logHeatmapFilterTapped;
